import React from "react";

const BallRipple = () => {
  return (
    <div className="loader">
      <div className="ball-scale-ripple">
        <div />
      </div>
    </div>
  );
};

export default BallRipple;
